import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputTextComponent} from './form-input-text.component';
import {InputTextModule} from 'primeng/inputtext';
import {KeyFilterModule} from 'primeng/keyfilter';
import {SharedModule} from '../../../modules/shared/shared.module';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';

@NgModule({
  declarations: [
    FormInputTextComponent
  ],
  exports: [
    FormInputTextComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InputTextModule,
    KeyFilterModule,
    FormInputErrorModule
  ]
})
export class FormInputTextModule {
}
